import { Nav } from "@/components/rgp/Nav";
import { Hero } from "@/components/rgp/Hero";
import { Ticker } from "@/components/rgp/Ticker";
import { About } from "@/components/rgp/About";
import { Constitution } from "@/components/rgp/Constitution";
import { Committee } from "@/components/rgp/Committee";
import { Membership } from "@/components/rgp/Membership";
import { Donation } from "@/components/rgp/Donation";
import { Contact } from "@/components/rgp/Contact";
import { Footer } from "@/components/rgp/Footer";

export default function Landing() {
  return (
    <main className="bg-[#0B0B0E] text-white overflow-x-hidden">
      <Nav />
      <Hero />
      <Ticker />
      <About />
      <Constitution />
      <Committee />
      <Membership />
      <Donation />
      <Contact />
      <Footer />
    </main>
  );
}
